import { useQueryClient, useMutation } from 'react-query'
import { api } from '../../utils/gql-client'
import {
  CreateClientMutationVariables as Variables,
  CreateClientMutation as Response
} from '../../API'
import { createClient as query } from '../../graphql/mutations'
import { CLIENTS_KEY } from '../../utils/hooks/clients'

function useCreateClient() {
  const queryClient = useQueryClient()

  return useMutation((variables: Variables) => {
    return api.request<Response>({ query, variables })
  }, {
    onSuccess: () => {
      return queryClient.invalidateQueries(CLIENTS_KEY)
    }
  })
}

export { useCreateClient }
